import type { JSX } from 'react';
import { Link } from 'react-router';

import { DesktopNavigation } from '@/components/layout/DesktopNavigation';
import { MobileNavigation } from '@/components/layout/MobileNavigation';
import { ThemeToggle } from '@/components/layout/ThemeToggle';
import { ButtonLink } from '@/components/ui/Button';
import { profile } from '@/content/profile';

export function Header(): JSX.Element {
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-background/85 backdrop-blur-md">
      <div className="shell-container flex min-h-16 items-center justify-between gap-4 py-3">
        <Link
          to="/"
          className="group inline-flex items-center gap-3 rounded-md no-underline"
          aria-label={`${profile.name} — home`}
        >
          <span
            aria-hidden="true"
            className="inline-flex size-9 items-center justify-center rounded-md bg-accent-solid font-mono text-sm font-semibold text-accent-contrast"
          >
            CC
          </span>
          <span className="hidden flex-col leading-tight sm:flex">
            <span className="text-sm font-semibold text-text">{profile.name}</span>
            <span className="text-xs text-muted">{profile.role}</span>
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <DesktopNavigation />
          <ButtonLink to="/contact" size="md" className="hidden sm:inline-flex">
            Get in touch
          </ButtonLink>
          <ThemeToggle />
          <MobileNavigation />
        </div>
      </div>
    </header>
  );
}
